import { isTestEnvironment } from '../getVGSProxyEndpoint';

const validateTourProviderAccount = (
  toursToBook,
  travelAgency,
  loggedInUserEmail,
  tourProviderAccount,
) => {
  const hasTours = (toursToBook || []).length > 0;
  const account = travelAgency && travelAgency.tourProviderAccount;
  const { token, doBookAsAgency } = tourProviderAccount || {};

  if (!hasTours || isTestEnvironment()) {
    return null;
  }

  if (!account || !loggedInUserEmail) {
    return null;
  }

  if (account.hasOwnToken || token || doBookAsAgency) {
    return null;
  }

  if (account.isConnected) {
    return 'Paste your Project Expedition access token, or choose to book these tours as the agency.';
  }

  return 'Enter your Project Expedition access token to book these tours.';
};

export default validateTourProviderAccount;
